(() => {
  const lock = () => document.body.classList.add('mb-review-lock');
  const unlock = () => document.body.classList.remove('mb-review-lock');

  function initModals(root) {
    const modal = root.querySelector('[data-mb-review-modal]');
    if (!modal) return;
    const media = modal.querySelector('[data-mb-modal-media]');
    const name = modal.querySelector('[data-mb-modal-name]');
    const title = modal.querySelector('[data-mb-modal-title]');
    const date = modal.querySelector('[data-mb-modal-date]');
    const text = modal.querySelector('[data-mb-modal-text]');
    const product = modal.querySelector('[data-mb-modal-product]');
    const productImage = modal.querySelector('[data-mb-modal-product-image]');
    const productTitle = modal.querySelector('[data-mb-modal-product-title]');
    const close = () => { modal.classList.remove('is-open'); modal.setAttribute('aria-hidden', 'true'); unlock(); };
    const open = card => {
      media.src = card.dataset.mediaUrl || '';
      media.hidden = !card.dataset.mediaUrl;
      name.textContent = card.dataset.name || 'Cliente Maison Banus';
      title.textContent = card.dataset.title || '';
      title.hidden = !card.dataset.title;
      date.textContent = card.dataset.date || '';
      text.textContent = card.dataset.text || '';
      product.href = card.dataset.productUrl || '#';
      product.hidden = !card.dataset.productUrl;
      productImage.src = card.dataset.productImage || '';
      productTitle.textContent = card.dataset.productTitle || '';
      modal.classList.add('is-open'); modal.setAttribute('aria-hidden', 'false'); lock();
    };
    root.addEventListener('click', event => {
      const card = event.target.closest('[data-mb-review-card]');
      if (!card || !root.contains(card)) return;
      event.preventDefault();
      open(card);
    });
    modal.querySelector('[data-mb-modal-close]')?.addEventListener('click', close);
    modal.addEventListener('click', e => { if (e.target === modal) close(); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && modal.classList.contains('is-open')) close(); });
  }

  function initStories(root) {
    const viewer = root.querySelector('[data-mb-story-viewer]');
    if (!viewer) return;
    const slides = [...viewer.querySelectorAll('.mb-story-slide')];
    const bars = [...viewer.querySelectorAll('.mb-story-progress i')];
    if (!slides.length) return;
    const previewFrames = [...root.querySelectorAll('.mb-story-launcher__frame')];
    let previewIndex = 0;
    if (previewFrames.length) {
      previewFrames[0].classList.add('is-active');
      if (previewFrames.length > 1) {
        window.setInterval(() => {
          previewFrames[previewIndex].classList.remove('is-active');
          previewIndex = (previewIndex + 1) % previewFrames.length;
          previewFrames[previewIndex].classList.add('is-active');
        }, 2500);
      }
    }
    let index = 0, timer = null, started = 0, remaining = 6000, paused = false;
    const stopVideo = slide => { const v = slide?.querySelector('video'); if (v) { v.pause(); v.currentTime = 0; } };
    const fill = (i, value, duration = 0) => { const bar = bars[i]; if (!bar) return; bar.style.transition = duration ? `width ${duration}ms linear` : 'none'; bar.style.width = value; };
    const schedule = duration => { clearTimeout(timer); started = Date.now(); requestAnimationFrame(() => fill(index, '100%', duration)); timer = setTimeout(() => show(index + 1), duration); };
    const show = next => {
      stopVideo(slides[index]); clearTimeout(timer);
      if (next >= slides.length) return close();
      if (next < 0) next = 0;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === next));
      bars.forEach((bar, i) => fill(i, i < next ? '100%' : '0%'));
      index = next; remaining = Number(slides[index].dataset.duration) || 6000; paused = false;
      const video = slides[index].querySelector('video'); if (video) video.play().catch(() => {});
      schedule(remaining);
    };
    const open = () => { viewer.classList.add('is-open'); viewer.setAttribute('aria-hidden', 'false'); lock(); show(0); };
    const close = () => { clearTimeout(timer); stopVideo(slides[index]); viewer.classList.remove('is-open'); viewer.setAttribute('aria-hidden', 'true'); unlock(); };
    const pause = () => {
      const video = slides[index].querySelector('video');
      if (!paused) { remaining = Math.max(250, remaining - (Date.now() - started)); clearTimeout(timer); fill(index, getComputedStyle(bars[index]).width); if (video) video.pause(); paused = true; }
      else { if (video) video.play().catch(() => {}); paused = false; schedule(remaining); }
    };
    root.querySelector('[data-mb-story-open]')?.addEventListener('click', open);
    viewer.querySelector('[data-mb-story-close]')?.addEventListener('click', close);
    viewer.querySelector('[data-mb-story-pause]')?.addEventListener('click', pause);
    viewer.querySelectorAll('[data-mb-story-next]').forEach(b => b.addEventListener('click', () => show(index + 1)));
    viewer.querySelectorAll('[data-mb-story-prev]').forEach(b => b.addEventListener('click', () => show(index - 1)));
    document.addEventListener('keydown', e => { if (!viewer.classList.contains('is-open')) return; if (e.key === 'Escape') close(); if (e.key === 'ArrowRight') show(index + 1); if (e.key === 'ArrowLeft') show(index - 1); });
  }

  function initTracks(root) {
    root.querySelectorAll('[data-mb-track][data-mb-autoplay="true"]').forEach(track => {
      const cards = [...track.children];
      if (cards.length < 2) return;
      const highlightCentered = () => {
        const trackCenter = track.scrollLeft + (track.clientWidth / 2);
        let nearest = cards[0];
        let nearestDistance = Infinity;
        cards.forEach(card => {
          const cardCenter = card.offsetLeft + (card.offsetWidth / 2);
          const distance = Math.abs(cardCenter - trackCenter);
          if (distance < nearestDistance) { nearest = card; nearestDistance = distance; }
        });
        cards.forEach(card => card.classList.toggle('is-centered', card === nearest));
        index = Math.max(0, cards.indexOf(nearest));
      };
      const centerCard = (card, behavior = 'smooth') => {
        track.scrollTo({ left: card.offsetLeft - ((track.clientWidth - card.offsetWidth) / 2), behavior });
        cards.forEach(item => item.classList.toggle('is-centered', item === card));
      };
      let index = cards.length > 2 ? 1 : 0, timer, scrollFrame;
      const advance = () => {
        index = (index + 1) % cards.length;
        centerCard(cards[index]);
      };
      const start = () => { clearInterval(timer); timer = setInterval(advance, 3200); };
      const stop = () => clearInterval(timer);
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(scrollFrame);
        scrollFrame = requestAnimationFrame(highlightCentered);
      }, { passive: true });
      track.addEventListener('pointerdown', stop, { passive: true });
      track.addEventListener('pointerup', start, { passive: true });
      track.addEventListener('mouseenter', stop);
      track.addEventListener('mouseleave', start);
      requestAnimationFrame(() => centerCard(cards[index], 'auto'));
      start();
    });
  }

  function initReveal(root) {
    const items = root.querySelectorAll('.mb-review-card,.mb-reviews__media-card,.mb-mixed-quote');
    if (!('IntersectionObserver' in window)) { items.forEach(item => item.classList.add('is-visible')); return; }
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
    }), { threshold: .18 });
    items.forEach(item => observer.observe(item));
  }

  function init(root) { if (root.dataset.mbReady) return; root.dataset.mbReady = 'true'; initModals(root); initStories(root); initTracks(root); initReveal(root); }
  const initAll = scope => {
    if (scope.matches?.('[data-mb-reviews]')) init(scope);
    scope.querySelectorAll('[data-mb-reviews]').forEach(init);
  };
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-mb-open-product-review]');
    if (!trigger) return;
    const reviewCard = document.querySelector('.mb-reviews--product_preview [data-mb-review-card]');
    if (!reviewCard) return;
    event.preventDefault();
    reviewCard.click();
  });
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => initAll(document)) : initAll(document);
  document.addEventListener('shopify:section:load', e => initAll(e.target));
})();
